// UCL-wide color palette for use in all components
export type UCLColorKey =
  | "neutral-gray"
  | "silver"
  | "sky-blue"
  | "sunset-red"
  | "golden-yellow"
  | "midnight-navy"
  | "forest-green"
  | "desert-sand"
  | "peach-blush"
  | "cool-mint"
  | "deep-purple"
  | "steel-gray"
  | "bright-coral"
  | "warm-mocha"
  | "citrus-orange"
  | "lemon-zest"
  | "lavender-fog"
  | "aqua-wave"
  | "charcoal"
  | "cream"
  | "lime-punch"
  | "dusty-rose"
  | "ocean-teal"
  | "storm-blue"
  | "platinum";

export const UCLColors: Record<UCLColorKey, string> = {
  "neutral-gray": "#C0C0C0",
  silver: "#C0C0C0",
  "sky-blue": "#4D85EB",
  "sunset-red": "#E96077",
  "golden-yellow": "#F9C74F",
  "midnight-navy": "#1E2A38",
  "forest-green": "#63A480",
  "desert-sand": "#EDC9AF",
  "peach-blush": "#FFCBA4",
  "cool-mint": "#A3E4D7",
  "deep-purple": "#6C3483",
  "steel-gray": "#A9A9A9",
  "bright-coral": "#FF6F61",
  "warm-mocha": "#A9746E",
  "citrus-orange": "#FFA500",
  "lemon-zest": "#FFD166",
  "lavender-fog": "#D8BFD8",
  "aqua-wave": "#00CED1",
  charcoal: "#444444",
  cream: "#FFFDD0",
  "lime-punch": "#D4ED00",
  "dusty-rose": "#C08081",
  "ocean-teal": "#008080",
  "storm-blue": "#5A7D9A",
  platinum: "#E5E4E2",
}; 